import { render, staticRenderFns } from "./ReceptionAddNew.vue?vue&type=template&id=1df5e6a4&scoped=true"
import script from "./ReceptionAddNew.vue?vue&type=script&lang=js"
export * from "./ReceptionAddNew.vue?vue&type=script&lang=js"
import style0 from "./ReceptionAddNew.vue?vue&type=style&index=0&id=1df5e6a4&prod&lang=scss&scoped=true"
import style1 from "./ReceptionAddNew.vue?vue&type=style&index=1&id=1df5e6a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df5e6a4",
  null
  
)

export default component.exports